import NadiaMarkBalance from "./NadiaMarkBalance.vue";
import NadiaMarkHop from "./NadiaMarkHop.vue";
import NadiaMarkPop from "./NadiaMarkPop.vue";
import NadiaMarkTwirl from "./NadiaMarkTwirl.vue";

export const NADIA_MARKS = [NadiaMarkBalance, NadiaMarkPop, NadiaMarkHop, NadiaMarkTwirl] as const;
